import Joi from 'joi';

/**
 * Schema for validating payment value.
 * @description This schema ensures that the `totalNet` value is a required number, with specific error messages for invalid types or excessive length.
 * Additional properties beyond those defined in the schema are allowed, so extra data in the object will not cause validation errors.
 */
export const paySchema = () =>
	Joi.object({
		totalNet: Joi.number().min(0.00001).max(99999999).required().messages({
			'number.base': 'validations|pay|total-net-value-must-be-number',
			'number.unsafe': 'validations|pay|total-net-value-too-long',
			'any.required': 'validations|pay|total-net-value-required',
			'number.max': 'validations|pay|total-net-value-too-long',
			'number.min': 'validations|pay|total-net-value-required',
		}),
	}).unknown(true);
